import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { DatabaseBackup, Mail, ArrowRight } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
const TONE = {
  green: { dot: "bg-emerald-400", ring: "shadow-[0_0_0_4px_rgba(52,211,153,0.18)]", text: "text-emerald-300", label: "OK" },
  yellow: { dot: "bg-amber-400", ring: "shadow-[0_0_0_4px_rgba(251,191,36,0.18)]", text: "text-amber-300", label: "Attenzione" },
  red: { dot: "bg-red-500", ring: "shadow-[0_0_0_4px_rgba(239,68,68,0.2)]", text: "text-red-300", label: "Problema" },
};

// Card Dashboard "Ultimo backup": semaforo + data + clienti salvati (solo admin)
export default function BackupStatusCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/customer-backups/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const t = TONE[s.status] || TONE.red;
  const last = s.last;
  return (
    <Link to="/clienti" className="card-elev p-5 flex flex-col gap-3 dash-tint dash-tint-mint" data-testid="backup-status-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-zinc-300 font-heading font-semibold"><DatabaseBackup className="h-4 w-4 text-sky-300" /> Ultimo backup clienti</div>
        <span className="flex items-center gap-1.5 text-xs font-semibold" data-testid={`backup-status-${s.status}`}>
          <span className={`h-2.5 w-2.5 rounded-full ${t.dot} ${t.ring}`} />
          <span className={t.text}>{t.label}</span>
        </span>
      </div>
      {last ? (
        <>
          <div className="flex items-end justify-between gap-3">
            <div>
              <div className="font-heading text-2xl font-bold text-zinc-100" data-testid="backup-status-customers">{last.customers}</div>
              <div className="text-[11px] text-zinc-500">clienti salvati · {last.transactions ?? 0} movimenti{last.reservations != null ? ` · ${last.reservations} prenotazioni` : ""}{last.customer_coupons != null ? ` · ${last.customer_coupons} coupon` : ""}</div>
            </div>
            <div className="text-right">
              <div className="text-sm text-zinc-200" data-testid="backup-status-date">{fmt(last.created_at)}</div>
              <div className="text-[11px] text-zinc-500">{last.trigger === "cron" ? "automatico" : "manuale"}{s.age_hours != null ? ` · ${s.age_hours < 1 ? "meno di 1h" : `${Math.round(s.age_hours)}h`} fa` : ""}</div>
            </div>
          </div>
          <div className={`text-[11px] ${t.text}`} data-testid="backup-status-reason">{s.reason}</div>
          {s.email_enabled && (
            <div className="text-[11px] text-zinc-500 flex items-center gap-1"><Mail className="h-3 w-3" /> {last.emailed_at ? `email inviata a ${last.emailed_to}` : last.email_error ? `email non inviata: ${last.email_error}` : last.trigger === "cron" ? "email in attesa" : "email solo per i backup notturni"}</div>
          )}
        </>
      ) : (
        <div className="text-sm text-zinc-400" data-testid="backup-status-reason">{s.reason}. Il primo backup verrà creato stanotte alle 02:30.</div>
      )}
      <div className="text-[11px] text-zinc-500 flex items-center gap-1 mt-auto">Gestisci in Clienti → Cestino / Backup <ArrowRight className="h-3 w-3" /></div>
    </Link>
  );
}
